import to from './to';
import { DOWNLOAD } from '../service/base-api-service';
import { toast } from 'react-toastify';

export const downloadPdf = async (serviceFormId, isAdmin, tenantId, ASR = false) => {
  isAdmin = true;
  const [err, data] = await to(
    DOWNLOAD(`v1/${isAdmin ? 'admin/' : ''}report/${ASR ? 'afterS' : 's'}ervice/${serviceFormId}?tenantId=${tenantId}`),
  );
  if (err) {
    return toast.error('Unable to download');
  }

  const url = window.URL.createObjectURL(new Blob([data.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', serviceFormId + '.pdf'); //or any other extension
  document.body.appendChild(link);
  link.click();
};

export const downloadHandoverPdf = async ({ tenantId, siteId, fileName, isAdmin }) => {
  const encodedFileName = encodeURIComponent(fileName || 'handover-report.pdf');
  const adminPrefix = isAdmin ? 'admin/' : '';
  const [err, data] = await to(
    DOWNLOAD(`v1/${adminPrefix}service-handover/file?tenantId=${tenantId}&siteId=${siteId}&fileName=${encodedFileName}`),
  );

  if (err) {
    return toast.error('Unable to download handover report');
  }

  const url = window.URL.createObjectURL(new Blob([data.data], { type: 'application/pdf' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName || 'handover-report.pdf');
  document.body.appendChild(link);
  link.click();
};

const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

// Content-Disposition can use RFC 5987 (filename*=UTF-8''...) or a plain/quoted filename.
const parseFileNameFromDisposition = (disposition) => {
  if (!disposition || typeof disposition !== 'string') return '';

  const extended = /filename\*\s*=\s*([^']*)''([^;]+)/i.exec(disposition);
  if (extended?.[2]) {
    try {
      return decodeURIComponent(extended[2].trim().replace(/^"|"$/g, ''));
    } catch (e) {
      return extended[2].trim().replace(/^"|"$/g, '');
    }
  }

  const basic = /filename\s*=\s*("([^"]*)"|[^;]+)/i.exec(disposition);
  if (basic) {
    return (basic[2] || basic[1] || '').trim().replace(/^"|"$/g, '');
  }

  return '';
};

const triggerBlobDownload = (blob, fileName) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
};

const readBlobAsText = (blob) =>
  new Promise((resolve) => {
    try {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ''));
      reader.onerror = () => resolve('');
      reader.readAsText(blob);
    } catch (e) {
      resolve('');
    }
  });

export const downloadServiceExpiryReport = async ({ siteId, siteName }) => {
  if (siteId === undefined || siteId === null || siteId === '') {
    toast.error('Please select a site first');
    return false;
  }

  const [err, res] = await to(
    DOWNLOAD(`v1/report/service-expiry/download?siteId=${encodeURIComponent(siteId)}`),
  );

  if (err) {
    toast.error(err?.message || 'Unable to download service expiry report');
    return false;
  }

  const payload = res?.data;

  // A blob-typed response can still carry a JSON error body.
  if (payload instanceof Blob && payload.type && payload.type.includes('json')) {
    const text = await readBlobAsText(payload);
    let message = 'Unable to download service expiry report';
    try {
      message = JSON.parse(text)?.message || message;
    } catch (e) {
      /* keep default message */
    }
    toast.error(message);
    return false;
  }

  const safeSiteName = String(siteName || 'site')
    .trim()
    .replace(/[\\/:*?"<>|]+/g, '-')
    .replace(/\s+/g, '-');

  const fileName =
    parseFileNameFromDisposition(res?.headers?.['content-disposition'] || res?.headers?.['Content-Disposition']) ||
    `MineArc-Service-Expiry-Report-${safeSiteName}.xlsx`;

  triggerBlobDownload(new Blob([payload], { type: XLSX_MIME }), fileName);
  toast.success('Service expiry report downloaded');
  return true;
};
